export const SIDEBAR_TOGGLE = 'SIDEBAR_TOGGLE'
